import { t as StyledSvgIcon } from "./SvgIcon.styles-D2P4wvY9.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/feather/X.svg?react
const SvgX = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React$1.createElement("path", {
	d: "M18 6L6 18M6 6L18 18",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));

//#endregion
//#region src/icons/XIcon.tsx
function XIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgX,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { XIcon as t };
//# sourceMappingURL=XIcon-562bby7o.js.map